import { useCallback } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { PACKAGE_NAME, TEAM_NAME } from '../../common/constants.tsx';
import type { Options, RemoveConnectionCallback, StatusUpdateHandler } from './types.tsx';
import { useDeleteRecord } from './use-delete-record/index.tsx';
import { useCommitLocalUpdate } from './use-commit-local-update/index.tsx';

const DEFAULT_OPTIONS: Options = {
	isHideDoneEnabled: false,
};

export function useHandleStatusUpdate(
	itemsConnectionId: string,
	recordId: string,
	removeConnection: RemoveConnectionCallback,
	options: Options = DEFAULT_OPTIONS,
) {
	const updater = useDeleteRecord(itemsConnectionId, recordId, removeConnection);
	const handler = useCommitLocalUpdate(updater, options);

	return useCallback<StatusUpdateHandler>(
		(field) => {
			try {
				handler(field);
			} catch (error: unknown) {
				if (error instanceof Error) {
					fireErrorAnalytics({
						meta: {
							id: 'issue-table-hide-done-status-update',
							packageName: PACKAGE_NAME,
							teamName: TEAM_NAME,
						},
						error,
					});
				}
			}
		},
		[handler],
	);
}
